module.exports = __webpack_public_path__ + "img/Dantam Hair 34.410fbc38.jpg";